module.exports = __webpack_public_path__ + "static/media/8OLA4.16728227.jpg";